import store from '@/renderer/store';
import { DrawerEvents } from '@/renderer/store/modules/drawer';
interface DrawerHandlerMethods {
  // 设置抽屉相关及参数
  setDrawers: (scopes: Drawer.Scope<unknown>[]) => void;
  // 在点击选择变化的时候，更新tabs(同时需要把对应的参数传递过来)
  // updateDrawer: (params: any) => {},
  // 点击选择的类型不变时：精细化更新data数据变化(从A文件->B文件)
  // updateData: (params: any) => {},

  // 设置文件选择器出现与否
  setFileIndicator(config: Drawer.FileListSwitchConfig | null): void;
}

/**
 * 处理Drawer的控制
 * @param params
 */
export const drawerHandler = () => {
  const cacheDrawers: unknown[] = [];
  const drawerHandlerMethods: DrawerHandlerMethods = {
    setDrawers(scopes: Drawer.Scope<unknown>[]): void {
      store.commit(DrawerEvents.SET_DRAWERS, scopes);
    },
    setFileIndicator(config: Drawer.FileListSwitchConfig | null): void {
      store.commit(DrawerEvents.SET_DRAWERS_FILE_INDICATOR, config);
    },
  };
  return {
    drawerHandlerMethods,
  };
};
